import { render, staticRenderFns } from "./specifiedSearch.vue?vue&type=template&id=4b569180&scoped=true&"
import script from "./specifiedSearch.vue?vue&type=script&lang=js&"
export * from "./specifiedSearch.vue?vue&type=script&lang=js&"
import style0 from "./specifiedSearch.vue?vue&type=style&index=0&id=4b569180&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b569180",
  null
  
)

export default component.exports